import React from "react";
import { createUseStyles } from "react-jss";
import { ListCell } from "../..";
import { useTableContext } from "../../hooks/useTableContext";
import { classNames } from "../../utils/classNames";
import { SelectTableRowCheckbox } from "../SelectTableRowCheckbox";
import { getCellDataId, getCellDataTestId } from "../tableUtils";
import { DATA_COL_INDEX } from "../../utils/gridColumns";
export function TableRowActionAtStart(props) {
    var rowIndex = props.rowIndex, item = props.item, form = props.form;
    var classes = useTableActionClasses();
    var isBulk = useTableContext().isBulk;
    var cellDataId = getCellDataId(rowIndex, props === null || props === void 0 ? void 0 : props.dataId);
    var cellDataTestId = getCellDataTestId(rowIndex, props === null || props === void 0 ? void 0 : props.dataTestId);
    return (React.createElement(ListCell, { className: classNames("table-atStart", classes.action), ariaColIndex: 1, role: "cell", dataId: cellDataId && "".concat(cellDataId, "-table-atStart"), dataTestId: cellDataTestId && "".concat(cellDataTestId, "-table-at-start") }, (form === null || form === void 0 ? void 0 : form.values) && form.labelIdentifier && form.idIdentifier && (React.createElement(SelectTableRowCheckbox, { label: item[form.labelIdentifier], name: form.name, id: item[form.idIdentifier], invert: isBulk }))));
}
var useTableActionClasses = createUseStyles({
    action: {
        gridArea: "".concat(DATA_COL_INDEX, "1"),
        paddingTop: 0,
        paddingRight: "0px!important",
        paddingLeft: 0,
        minHeight: 30,
        gridColumn: 1,
    },
});
